var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"p-0",attrs:{"disabled":_vm.disabled,"title":_vm.title,"href":_vm.href,"to":_vm.to,"target":_vm.target,"variant":"link","size":"sm"}},[(_vm.icon && _vm.icon.length)?_c('fa',{attrs:{"icon":_vm.icon,"fixed-width":""}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }